import chunk from 'lodash.chunk';
import IBAN from 'iban';
import arrayFromNumber from './array/arrayFromNumber';

const getMaskForCountry = countryCode => {
  const ibanSpec = IBAN.countries[countryCode] ?? IBAN.countries.NL;
  const regexes = ibanSpec.structure.match(/(.{3})/g).reduce((acc, block) => {
    let format;
    const pattern = block.slice(0, 1);
    const repeats = parseInt(block.slice(1), 10);

    switch (pattern) {
      case 'A':
        format = /[0-9A-Za-z]/;
        break;
      case 'B':
        format = /[0-9A-Z]/;
        break;
      case 'C':
        format = /[A-Za-z]/;
        break;
      case 'F':
        format = /[0-9]/;
        break;
      case 'L':
        format = /[a-z]/;
        break;
      case 'U':
        format = /[A-Za-z]/;
        break;
      case 'W':
        format = /[0-9a-z]/;
        break;
      default:
        break;
    }

    const formats = arrayFromNumber(repeats).reduce(formatAcc => [...formatAcc, format], []);

    return [...acc, ...formats];
  }, []);

  return [
    /[A-Za-z]/,
    /[A-Za-z]/,
    /[0-9]/,
    /[0-9]/,
    ...chunk(regexes, 4).reduce((acc, chunked) => [...acc, ' ', ...chunked], []),
  ];
};

export default value => {
  const countryCode = value.slice(0, 2);
  return getMaskForCountry(countryCode?.length === 2 ? countryCode : 'NL');
};
